import React from "react";
import CopyLabel from "components/CopyLabel";
import styles from "components/modals/ErrorToastContent.module.css";
import { isNullOrEmpty } from "shared/Helpers";

const ErrorToastContent = (props) => {
  const closeToast = props.closeToast;
  const title = props.title;
  const errorId = props.errorId;
  const exception = props.exception;
  const errorMessageBody = !isNullOrEmpty(exception?.stack)
    ? exception.stack
    : !isNullOrEmpty(exception?.message)
    ? exception.message
    : exception;

  return (
    <div className={styles.container}>
      <div>{isNullOrEmpty(title) ? "An error has occurred." : title} Please provide the below error Id to Support.</div>
      <br />
      <div className={styles.errorcode}>
        <CopyLabel label="" value={errorId ? errorId : "Unknown"} />
      </div>
      <hr />
      <div className={styles.stacktrace}>
        <div>Error Message: </div>
        {errorMessageBody ? errorMessageBody : "Unknown Error"}
      </div>
      <div className={styles.buttoncontainer}>
        <button class={styles.closebutton} onClick={closeToast}>
          CLOSE
        </button>
      </div>
    </div>
  );
};

export default ErrorToastContent;
